module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[15]380.ad18499.woff2";